import { render, staticRenderFns } from "./Vigour.vue?vue&type=template&id=47ff29e8&scoped=true&"
import script from "./Vigour.vue?vue&type=script&lang=js&"
export * from "./Vigour.vue?vue&type=script&lang=js&"
import style0 from "./Vigour.vue?vue&type=style&index=0&id=47ff29e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ff29e8",
  null
  
)

export default component.exports